import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getObligation } from '../../../redux/actions/adminReport'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ObligationOfInstallmentWidget from '../../../widgets/adminReport/obligationOfInstallment/ObligationOfInstallmentWidget'
import ObligationWidget from '../../../widgets/adminReport/obligation/ObligationWidget'

export default function Obligation(props) {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getObligation()
      // console.log('_schema => ', _schema)
      // setSchema(_schema)
      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    // console.log('load AllProjectSummaryReport')
    handleGetSchema()
  }, [])

  if (error) {
    return (
      <SidebarProposal isReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }
  return (
    <SidebarProposal isReport>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

      <ObligationWidget schema={schema.form} />
    </SidebarProposal>
  )
}
